<template>
  <TabelaOSD
    :colunas="displayedColumns"
    :linhas="table.rows"
    :carregando="table.isLoading"
    :total-linhas="table.totalRows"
    :pagina="pagination.page"
    :campo-ordenacao="pagination.sort"
    :ordem-ordenacao="pagination.order"
    :texto-tabela-vazia="$t('indicadoresNaoEncontrados')"
    :campos-modal="obterCamposModal"
    @sort-change="onSortChange"
    @page-change="onPageChange"
    @reload="obterEmpresas"
  >
    <template #toolbar-actions>
      <EmpresasExport v-bind="pagination" :headers="headers" />
    </template>
    <template #toolbar-filters>
      <EmpresasFilters :loading="table.isLoading" @filter="onFilter" />
    </template>
  </TabelaOSD>
</template>

<script>
import EmpresasExport from './EmpresasExport.vue';
import EmpresasFilters from './EmpresasFilters.vue';
import TabelaOSD from '@/modules/shared/components/tabelaOSD/TabelaOSD.vue';
import { getPaginatedEmpresasData } from '../empresasService';
import { useToast } from 'vue-toastification';
import { toDate, toPhone } from '@/modules/core/utils/formats';

const HIDDEN_FIELDS = ['identificador', 'telefone'];

export default {
  components: { EmpresasExport, EmpresasFilters, TabelaOSD },
  data: () => ({
    columns: [
      { labelKey: 'identificador', field: 'identificador' },
      { labelKey: 'nome', field: 'razaoSocial', tdClass: 'coluna-larga' },
      { labelKey: 'dataHoraCriacao', field: 'dataHoraCriacao', formatFn: toDate },
      { labelKey: 'telefone', field: 'telefone', formatFn: toPhone },
      { labelKey: 'celular', field: 'celular', formatFn: toPhone },
      { labelKey: 'usuario', field: 'usuarios', tdClass: 'text-break', plural: true },
      { labelKey: 'qtdOS', field: 'totalOS' },
      { labelKey: 'municipio', field: 'municipio' },
      { labelKey: 'uf', field: 'estado' },
      { labelKey: 'status', field: 'status' },
      { labelKey: 'dataUltimaOs', field: 'dataUltimaOs', tdClass: 'text-break', formatFn: toDate },
    ],
    table: {
      totalRows: 0,
      rows: [],
      isLoading: false,
    },
    pagination: {
      page: 1,
      sort: 'dataHoraCriacao',
      order: 'desc',
      search: '',
    },
  }),
  computed: {
    displayedColumns() {
      return this.columns.filter((column) => !HIDDEN_FIELDS.includes(column.field));
    },
    headers() {
      return this.columns.map((column) => {
        if (column.plural) return this.$t(column.labelKey, column.pluralQuantidade || 2);
        return this.$t(column.labelKey);
      });
    },
  },
  methods: {
    obterCamposModal(linha) {
      return [
        { titulo: this.$t('identificador'), valor: linha.identificador },
        { titulo: this.$t('uuid'), valor: linha.uuid },
        { titulo: this.$t('telefone'), valor: linha.telefone },
      ];
    },
    onPageChange(page) {
      this.pagination = { ...this.pagination, page };
      this.obterEmpresas();
    },
    onSortChange(field) {
      const nextOrder = this.pagination.sort === field && this.pagination.order === 'asc' ? 'desc' : 'asc';
      this.pagination = { ...this.pagination, page: 1, sort: field, order: nextOrder };
      this.obterEmpresas();
    },
    onFilter(filters) {
      this.pagination = { ...this.pagination, ...filters, page: 1 };
      this.obterEmpresas();
    },
    async obterEmpresas() {
      this.table.isLoading = true;
      try {
        const data = await getPaginatedEmpresasData(this.pagination);
        this.table.rows = data.dados;
        this.table.totalRows = data.total;
      } catch (error) {
        useToast().error(this.$t('erroAoObterAsInfosDasEmpresas'));
      }
      this.table.isLoading = false;
    },
  },
};

</script>
